export const ACCESSOIRE = {
  title: 'Liste des accessoires',
  breadcrumb: {
    liste: 'Liste des accessoires',
  },
  actions: {
    add: 'Ajouter un accessoire',
  },
  tab: {
    libelle: 'Libellé',
    fournisseur: 'Fournisseur',
    commentaire: 'Commentaire',
    actif: 'Archivé',
  },
  popUpArchivage: {
    titleArchiver: 'Êtes-vous sûr de vouloir archiver cet accessoire ?',
    titleDesarchiver: 'Êtes-vous sûr de vouloir désarchiver cet accessoire ?',
  },
  popUpDelete: {
    title: 'Êtes-vous sûr de vouloir supprimer cet accessoire ?',
  },
  messages: {
    success: {
      delete: 'Accessoire supprimé avec succès.',
      archiver: 'Accessoire archivé avec succès.',
      desarchiver: 'Accessoire désarchivé avec succès.',
    },
    error: {
      accessoireLierOT: 'Impossible de supprimer l\'accessoire "{libelle}" car il est lié à/aux OT(s) techniques {code}.',
      accessoireLierPatrimoine: 'Impossible de supprimer l\'accessoire "{libelle}" car il est lié à un/des patrimoine(s) {code}.',
    },
  },
  filtres: {
    actif: {
      tilte: 'Actif',
    },
  },
};

export const ADD_EDIT_ACCESSOIRE = {
  titleEdit: 'Editer un accessoire',
  titleAdd: 'Ajouter un accessoire',
  information: {
    libelle: 'Libellé',
    fournisseur: 'Fournisseur',
    commentaire: 'Commentaire',
  },
  success: {
    add: 'L\'accessoire a été ajouté avec succès.',
    edit: 'L\'accessoire a été modifié avec succès.',
  },
};
